import { Box, Breadcrumbs, Button, Chip, Divider, Link, Stack } from "@mui/joy";
import { Helmet } from "react-helmet";
import { Grid2, Paper, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { centrado } from "../utils/Estilos";
import { theme2 } from "../theme";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Cargando } from "../utils/Cargando";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import ShareIcon from "@mui/icons-material/Share";
import no from "../assets/image/no.png";

export const CursoDetalle = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [objeto, setObjeto] = useState({});

  const [imagen, setImagen] = useState(null);

  const dispatch = useDispatch();
  const carrito = useSelector((state) => state.carrito?.carro ?? []);

  const espeImagenes = useSelector(
    (state) => state.especialidades?.espeImagenes ?? [],
  );

  useEffect(() => {
    cargar();
  }, []);

  function formatear(listaD) {
    let grupos = listaD.reduce((acumulador, el) => {
        const clave = `${el?.producto?.id}_${el?.eleccion}_${el?.espe}`;
      if (!acumulador[clave]) {
        acumulador[clave] = {
          ...el,
        };
      }
      return acumulador;
    }, {});

    let final = [];

    for (const el of Object.keys(grupos)) {
      let val = grupos[el];
      let precio = !isNaN(val?.eleccion)
        ? [val?.producto?.precio1, val?.producto?.precio2][val?.eleccion]
        : val?.producto?.precio;
      precio = parseFloat(precio).toFixed(2);
      final.push({
        ...val,
        precioFinal: precio,
        total: (parseFloat(precio)).toFixed(2),
      });
    }
    dispatch({
      type: "CARRO_SUCCESS",
      payload: {
        carro: final,
      },
    });
    localStorage.setItem("carritoPublimed", JSON.stringify(final));
    setObjeto({
      producto: objeto?.producto,
    });
    Swal.fire({
      icon: "success",
      text: "Producto añadido al carrito",
    });
  }

  function cargarImagen(imagenid) {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      "https://portal.publimed.net/api/v1/Attachment/file/" + imagenid,
      requestOptions,
    )
      .then((response) => response.blob())
      .then((result) => {
        setImagen(URL.createObjectURL(result));
      })
      .catch((error) => console.error(error));
  }

  function cargar() {
    const myHeaders = new Headers();
    myHeaders.append("X-Api-Key", process.env.REACT_APP_TOKEN);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch("https://portal.publimed.net/api/v1/CCurso/" + id, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        if (res?.estado !== "ACTIVO") {
          Swal.fire({
            icon: "error",
            text:
              "Error: " +
              "El producto " +
              res.name +
              " ya no se encuentra activo",
          });
          navigate("/cursos");
        }
        if (res?.fotoId) {
          cargarImagen(res?.fotoId);
          setObjeto({
            producto: {
              ...res,
            },
          });
        }
      })
      .catch((error) => {
        console.error(error);
        navigate("/publicaciones");
      });
  }

  return (
    <Box py={3} sx={{ width: "100%", ...centrado, flexWrap: "wrap" }}>
      <Helmet>
        <title>{objeto?.producto?.name}</title>
      </Helmet>
      <Cargando open={!objeto?.producto?.name} />
      {objeto?.producto?.name && (
        <>
          <Box sx={{ width: "90%" }}>
            <Breadcrumbs sx={{ fontSize: "24px" }}>
              <Link
                underline="always"
                color="primary"
                onClick={() => navigate("/cursos")}
              >
                <strong>Cursos</strong>
              </Link>
            </Breadcrumbs>
          </Box>
          <Box sx={{ width: "90%" }}>
            <Grid2 container sx={{ width: "100%", ...centrado }}>
              <Grid2
                size={{ xs: 12, md: 4 }}
                sx={{ padding: "20px", border: 1 }}
              >
                {objeto?.producto?.imagen && !imagen && (
                  <img
                    alt={"fotoProducto"}
                    src={
                      "https://publimed.net/iconos/" + objeto?.producto?.imagen
                    }
                    width={"100%"}
                  />
                )}

                {objeto?.producto?.especialidades?.length > 0 && !imagen && (
                  <img
                    alt={"fotoProducto"}
                    src={
                      espeImagenes[
                        objeto?.producto?.especialidades.filter(
                          (val2) =>
                            espeImagenes[val2] !==
                            "https://publimed.net/iconos/new/no.png",
                        )[0]
                      ] ?? no
                    }
                    width={"100%"}
                  />
                )}

                {imagen && (
                  <img alt={"fotoProducto"} src={imagen ?? no} width={"100%"} />
                )}
                <Box sx={{ width: "100%", ...centrado, justifyContent: "end" }}>
                  <Button
                    variant="outlined"
                    onClick={() =>
                      navigator.clipboard.writeText(window.location.href)
                    }
                    sx={{ gap: 1, fontSize: "16px" }}
                  >
                    Copiar URL <ShareIcon />
                  </Button>
                </Box>
              </Grid2>
              <Grid2 size={{ xs: 12, md: 8 }} sx={{ padding: "20px" }}>
                <Paper
                  elevation={2}
                  sx={{
                    padding: "20px",
                    border: 1,
                    borderRadius: "25px",
                    minHeight: "400px",
                    borderColor: theme2.palette.primary.main,
                  }}
                >
                  <Typography fontWeight={"bold"} variant="h5">
                    {objeto?.producto?.name}
                  </Typography>
                  <Divider />
                  <br />
                  {objeto?.producto?.especialidades?.length > 0 && (
                    <>
                      <Typography variant="h6">
                        <strong>Especialidades:</strong>{" "}
                        {objeto?.producto?.especialidades?.join(", ")}
                      </Typography>
                      <br />
                    </>
                  )}
                  <Typography fontWeight={"bold"} variant="h6">
                    Descripción
                  </Typography>
                  <Typography variant="h6" sx={{ whiteSpace: "break-spaces" }}>
                    {objeto?.producto?.description}
                  </Typography>
                  <Typography fontWeight={"bold"} variant="h6" pt={2}>
                    Precio
                  </Typography>

                  {objeto?.producto?.descuento === "SI" && (
                    <Chip
                      color="neutral"
                      size="lg"
                      sx={{ textDecoration: "line-through", padding: "5px" }}
                    >
                      {"$ " +
                        parseFloat(
                          objeto?.producto?.preciodescuento,
                        ).toFixed(2)}
                    </Chip>
                  )}
                  <Chip color="success" size="lg" sx={{ padding: "5px" }}>
                    {"$ " + parseFloat(objeto?.producto?.precio).toFixed(2)}
                  </Chip>
                  <br />
                  <br />
                  <Divider />
                  <br />
                  <Button
                    onClick={() => {
                      let lis = carrito.filter(
                        (va) => !(va?.producto?.id === objeto?.producto?.id),
                      );
                      lis.push({
                        producto: objeto?.producto,
                      });

                      formatear(lis);
                    }}
                    endDecorator={
                      <ShoppingCartIcon sx={{ fontSize: "24px" }} />
                    }
                    variant="solid"
                  >
                    <Typography
                      fontWeight={"bold"}
                      sx={{ textAlign: "center" }}
                    >
                      Añadir al carrito
                    </Typography>
                  </Button>
                </Paper>
              </Grid2>
            </Grid2>
          </Box>
        </>
      )}
    </Box>
  );
};
